@if (facetList$ | async; as facetList) {
  <ng-container class="">
    <div class="float-left w-100">
      @if (facetList?.activeFacets?.length > 0) {
        <h4 class="filter-title color-knbr-primary p-3 text-white m-0">
          {{ 'productList.appliedFilter' | cxTranslate }}
        </h4>
      }
      @for (facet of facetList?.activeFacets; track facet) {
        <a class="color-light-bg color-font font-size p-2 rounded mr-2 mt-2 mb-2 float-left"
          routerLink="./" [queryParams]="getLinkParams(facet)"
          [cxFocus]="getFocusKey(facetList, facet)" (click)="linkClick()">
          <span>
            {{
            facet.facetValueName === 'true' || facet.facetValueName === 'false'
            ? facet.facetValueName === 'true'
            ? 'Yes'
            : 'No'
            : facet.facetValueName
            }}
            <cx-icon aria-hidden="true" [type]="closeIcon" class="applied-icon d-inline ml-2"></cx-icon></span>
          </a>
        }
        @if (facetList?.activeFacets?.length > 0) {
          <a
            class="font-size p-2 mr-2 mt-2 mb-2 float-left border-rounded" routerLink="./"
            [queryParams]="removeFacets(facetList?.activeFacets)" (click)="linkClick()">
            <span>
              Clear All
              <cx-icon aria-hidden="true" [type]="closeIcon" class="applied-icon d-inline ml-2" style="stroke-width: 2px;"></cx-icon></span>
            </a>
          }
        </div>
      </ng-container>
    }
